import React, { Fragment, useMemo } from 'react'
import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'
import { Tooltip, useMediaQuery } from '@mui/material'
import styled from 'styled-components'

import { DEFAULT_CHAR_LIMIT } from 'lib/GlobalConstants'
import { Props, DefaultProps } from './Types'
import { ELLIPSIS_LENGTH, CreateDeleteIcon, ChipLabel } from './Helper'

const ChipWrapper = styled(Chip)({
  margin: '0.188rem 0.375rem 0.188rem 0 !important',
})

const ChipsList = (props: Props | any) => {
  const {
    chipData,
    variant,
    size,
    chipKey,
    chipLabel,
    chipDelete,
    onChipDelete,
    showTooltip,
    tooltipText,
    sx,
    additionalProps,
  } = props

  const isMobile = useMediaQuery('(max-width:700px)')
  const deleteIcon = useMemo(
    () => chipDelete && CreateDeleteIcon(showTooltip, tooltipText),
    [chipDelete, showTooltip, tooltipText],
  )

  const renderChip = (val: any) => {
    return (
      <ChipWrapper
        className="chip-item"
        variant={variant}
        size={size}
        key={val?.[chipKey] || val}
        label={ChipLabel(val, chipLabel)}
        deleteIcon={chipDelete ? deleteIcon : <></>}
        onDelete={() => onChipDelete(val)}
        disabled={isMobile}
        sx={{ ...sx }}
        {...additionalProps}
      />
    )
  }

  const renderWithTooltip = (val: any) => {
    return (
      <Tooltip
        key={val?.[chipKey] || val}
        placement="bottom"
        title={<>{val?.[chipLabel] || val}</>}
      >
        {renderChip(val)}
      </Tooltip>
    )
  }

  const renderWithoutTooltip = (val: any) => {
    return <Fragment key={val?.[chipKey] || val}>{renderChip(val)}</Fragment>
  }

  return (
    <Box>
      {chipData.map((val: any) => {
        const label = val?.[chipLabel] || val

        return label?.length > DEFAULT_CHAR_LIMIT + ELLIPSIS_LENGTH
          ? renderWithTooltip(val)
          : renderWithoutTooltip(val)
      })}
    </Box>
  )
}

ChipsList.defaultProps = DefaultProps

export default React.memo(ChipsList)
